import SampleReportView from "@/components/samples/SampleReportView";
import { SOLAR_OPTIMUM_REPORT } from "@/data/sample-reports";

const SolarOptimumSample = () => <SampleReportView report={SOLAR_OPTIMUM_REPORT} />;

export default SolarOptimumSample;
